var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7282 11L15.6303 19.2783L20.0415 28H16.2811L12.1351 19.2783L15.9919 11H19.7282ZM9.04964 11L12.9064 19.2783L8.76038 28H5L9.38711 19.2783L5.31337 11H9.04964ZM14.3045 18.071V20.387H10.52V18.071H14.3045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 11L29.3835 22.6043H25.9124L20.2718 11H24.1045L26.9007 17.258C27.0453 17.5865 27.1659 17.9396 27.2623 18.3174C27.3587 18.6952 27.4471 19.0565 27.5274 19.4014H27.7685C27.8649 19.0565 27.9613 18.6952 28.0578 18.3174C28.1542 17.9396 28.2667 17.5865 28.3952 17.258L31.1673 11H35ZM29.48 20.313V28H25.7919V20.313H29.48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXyIcon);
export default __webpack_public_path__ + "static/media/xy_icon.5eac6fee9286e56223dad0b0b0751732.svg";
export { ForwardRef as ReactComponent };